"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Collapsable = _interopRequireDefault(require("../Collapsable"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
var _ = require("..");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Left sidebar with filters rendered based on AppDefs
var FilterSideBar = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function FilterSideBar() {
    var _this;
    _classCallCheck(this, FilterSideBar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FilterSideBar, [].concat(args));
    _defineProperty(_this, "getTagLabel", function (tag) {
      if (tag === _.FAVORITES_FILTER_GROUP_KEY) {
        return 'Favorites';
      }
      var result = _this.props.filterTags.find(function (item) {
        return item.name === tag;
      });
      return result ? result.label : tag;
    });
    return _this;
  }
  _inherits(FilterSideBar, _React$Component);
  return _createClass(FilterSideBar, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        filterGroups = _this$props.filterGroups,
        filters = _this$props.filters,
        filterUpdater = _this$props.filterUpdater,
        displayOptions = _this$props.displayOptions;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h3", {
        style: {
          color: displayOptions.portal && displayOptions.portal.filterHeaderColor || 'inherit',
          backgroundColor: displayOptions.portal && displayOptions.portal.filterHeaderBackgroundColor || 'initial'
        },
        className: _style["default"].header
      }, "Filter by Criteria"), filterGroups.map(function (group, gIndex) {
        return /*#__PURE__*/_react["default"].createElement(_Collapsable["default"], {
          key: gIndex,
          title: group.name,
          icon: group.icon,
          color: group.color,
          collapsible: group.collapsible,
          isCollapsed: group.isCollapsed,
          displayOptions: displayOptions,
          getTagLabel: _this2.getTagLabel
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: displayOptions.portal && displayOptions.portal.filterGroupColor ? {
            backgroundColor: displayOptions.portal.filterGroupColor,
            color: displayOptions.portal.filterGroupTextColor
          } : {
            color: displayOptions.portal.filterGroupTextColor
          },
          className: 'form-check ' + _style["default"].filters
        }, group.tags.map(function (tag) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: tag,
            className: "input-group"
          }, /*#__PURE__*/_react["default"].createElement("label", {
            className: "form-check-label"
          }, /*#__PURE__*/_react["default"].createElement("input", {
            onChange: function onChange() {
              return filterUpdater(tag);
            },
            className: "form-check-input",
            type: "checkbox",
            checked: filters.includes(tag)
          }), _this2.getTagLabel(tag)));
        })));
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(FilterSideBar, "propTypes", {
  filterGroups: _propTypes["default"].array.isRequired,
  filterTags: _propTypes["default"].array.isRequired,
  filterUpdater: _propTypes["default"].func.isRequired,
  filters: _propTypes["default"].array.isRequired,
  displayOptions: _propTypes["default"].object
});